import Axios from '@/services/axios-instance/axios.service';

class PDFService {
  async uploadPDF(req) {
    const { data } = await Axios.post('/pdf/upload-pdf', req);
    return data;
  }
}

export default new PDFService();
